var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav-base',[_c('b-button',{staticClass:"nav-close h3",attrs:{"size":"lg","aria-label":_vm.label || _vm.$t('sr.close-panel'),"to":_vm.to},on:{"click":function($event){return _vm.$emit('close')}}},[_c('b-icon-x',{attrs:{"aria-hidden":"true"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }